import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { BoxMessage } from '../../models/boxmessage';

@Component({
  selector: 'app-info-pedido',
  templateUrl: './info-pedido.component.html',
  styleUrls: ['./info-pedido.component.scss']
})
export class InfoPedidoComponent extends BaseComponent implements OnInit {

  order:any;
  box_name:string;
  products:string;

  ngOnInit(): void {
    var device_info = this.localSession.getDeviceInfo();
  	this.order = this.localSession.getOrder();
    this.box_name = this.order.actual_device.name;
    this.products = this.order.order_details.map( (od) => od.product.name ).join(",");
  }

  openBox(): void{
    this.boxService.setOrderDone();
  }

}
